/**
 * useSpeakEngine — the public hook every consuming component uses.
 *
 * Usage:
 *   const { openCapture, isActive, closeCapture } = useSpeakEngine();
 *
 *   <button onClick={() => openCapture({
 *     preset: 'businessSetup',
 *     context: { existingCompanyName: 'Acme' },
 *     onResult: async (values) => {
 *       setRawInfo(values.rawInfo);
 *       setHintCompany(values.companyName);
 *       return 'Business dump ready — launching setup.'; // optional success msg
 *     },
 *   })} />
 */

import { useContext } from 'react';
import { SpeakEngineContext } from './SpeakEngineProvider';

export default function useSpeakEngine() {
  const ctx = useContext(SpeakEngineContext);
  if (!ctx) {
    // Fail loud rather than silently no-op — this catches "forgot to wrap in
    // SpeakEngineProvider" during dev, and returning fake fns would let
    // callers think their button worked while nothing actually opens.
    throw new Error('useSpeakEngine must be used within <SpeakEngineProvider>. Wrap your app (usually WorldLayout) with it.');
  }
  return ctx;
}
